import {Avatar} from '@/components/ui/avatar/Avatar'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {
    StyledAgendaResourceHeader,
    StyledAgendaResourceHeaderContent,
    StyledAgendaResourceSubtitle,
    StyledAgendaResourceTitle
} from '@/features/agenda/components/agenda-resource-header/style'
import {AgendaTeamResource} from '@/features/agenda/types'

export const AgendaResourceHeader = ({resource}: {resource: AgendaTeamResource}) => {
    return (
        <StyledAgendaResourceHeader gap={2} align="center" justify="center" fullWidth>
            <StyledAgendaResourceHeaderContent align="center" justify="center" gap={2}>
                <Avatar name={resource.resourceTitle} size={'sm'} />
                <Flexbox direction="column" gap={0.5}>
                    <StyledAgendaResourceTitle>{resource.resourceTitle}</StyledAgendaResourceTitle>
                    <StyledAgendaResourceSubtitle>{resource.specializationName}</StyledAgendaResourceSubtitle>
                </Flexbox>
            </StyledAgendaResourceHeaderContent>
        </StyledAgendaResourceHeader>
    )
}
